module.exports = __webpack_public_path__ + "static/media/book-space.aea14666.jpg";